import {Injectable} from '@angular/core';
import {RestHttpService} from '@catcore/services/rest-http.service';
import {Port, PortConnectorUnitCreateInfo} from '@catmodules/models/ports/types';
import {Restangular} from 'ngx-restangular';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class PortConnectorUnitService extends RestHttpService<Port> {

  constructor(service: Restangular) {
    super('port-connector-units\n', service);
  }

  create(item: PortConnectorUnitCreateInfo): Observable<any> {
    const payload = {
      port_model: item.portModel._links.self.href,
    };
    return this.queryAll().post(payload);
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/ports/services/port-connector-unit.service.ts